<template>
  <b-card
    :class="{panelHover: hover && !panelconfig.noHover}"
    no-body
    style="height: 100%; width: 100%; margin: 0; padding: 0;"
    @mouseover="hover = true"
    @mouseleave="hover = false"
  >
    <b-card-title
      v-if="!panelconfig.noHover"
      class="mt-2 ml-2"
    >
      Statistic Card Vertical
    </b-card-title>

    <!-- Meta Info -->
    <div
      v-if="panelconfig.noHover"
      class="d-flex mt-1 small text-muted justify-content-between "
    >
      <b-col
        class="text-left"
      >
        <feather-icon
          size="15"
          icon="CpuIcon"
        />
        {{ dataSource.name }}
      </b-col>
      <!--
      <b-col
        v-if="!edit"
        class="text-right"
        @click="showInfo = !showInfo"
      >
        <feather-icon
          size="15"
          icon="InfoIcon"
        />
      </b-col>
      -->
      <b-col
        v-if="edit"
        class="text-right"
      >
        <feather-icon
          v-if="edit"
          icon="EditIcon"
          class="text-primary cursor-pointer mr-2"
          size="18"
          variant="primary"
          @click="$emit('editPanel')"
        />
        <feather-icon
          v-if="edit"
          icon="XCircleIcon"
          class="text-danger cursor-pointer"
          size="20"
          variant="danger"
          @click="$emit('removeItem')"
        />
      </b-col>
    </div>

    <!-- Statistic -->
    <b-card-body class="text-center">
      <b-avatar
        class="mb-1"
        :variant="`light-${color}`"
        size="45"
      >
        <feather-icon
          size="21"
          :icon="icon"
        />
      </b-avatar>
      <div class="truncate">
        <h2 class="mb-25 font-weight-bolder">
          {{ statistic + ' ' }}
          {{ dataField.unit !== null ? dataField.unit : '' }}
        </h2>
        <span>Latest: {{ dataField.name }}</span>
      </div>
    </b-card-body>

    <!-- Footer -->
    <div
      v-if="panelconfig.noHover"
      class="d-flex mb-1 small text-muted"
    >
      <b-col
        class="text-left"
      >
        <b-row
          v-if="object.name !== undefined"
        >
          <b-col>
            <feather-icon
              size="15"
              icon="BoxIcon"
            />
            {{ object.name }}
          </b-col>
        </b-row>
        <b-row
          v-if="'site' in object && object.site !== null"
        >
          <b-col>
            <feather-icon
              size="15"
              icon="MapPinIcon"
            />
            {{ object.site.name }}
          </b-col>
        </b-row>

        <b-row
          v-if="timestamp !== ''"
        >
          <b-col>
            <feather-icon
              size="16"
              icon="ClockIcon"
            />
            {{ timestamp }}
          </b-col>
        </b-row>
      </b-col>
    </div>
    <div
      v-if="doesNotExist"
      class="overlay d-flex flex-column justify-content-center align-items-center"
    >
      <p>
        The data source does not exist
      </p>
      <p v-if="edit">
        <b-button
          variant="danger"
          size="sm"
          class="mt-1"
          @click="$emit('removeItem')"
        >
          Remove Panel
        </b-button>
      </p>
    </div>
  </b-card>
</template>

<script>
import {
  BRow,
  BCard,
  BCardBody,
  BAvatar,
  BCardTitle,
  BCol,
  BButton,
} from 'bootstrap-vue'
import { API } from 'aws-amplify'
import * as queries from '../../../../../../graphql/queries'

export default {
  components: {
    BRow,
    BCard,
    BCardBody,
    BAvatar,
    BCardTitle,
    BCol,
    BButton,
  },
  props: {
    panelconfig: {
      type: Object,
      default: () => ({
        dataSources: [],
        icon: {
          title: '',
          id: '',
        },
        color: '',
        hover: false,
      }),
    },
    edit: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      hover: false,
      statistic: 'Loading',
      timestamp: '',
      object: {},
      showInfo: false,
      doesNotExist: false,
      oldDataSourceId: '',
      oldSensorId: '',
      dataSource: {
        id: '',
        name: 'Loading',
        unit: '',
      },
      dataField: {
        name: 'Loading',
        unit: '',
      },
    }
  },
  computed: {
    icon: {
      get() {
        if (this.panelconfig.icon) {
          return this.panelconfig.icon.id
        }
        return 'CpuIcon'
      },
      set(value) {
        this.panelconfig.icon = value
      },
    },
    color: {
      get() {
        if (this.panelconfig.color) {
          return this.panelconfig.color
        }
        return 'primary'
      },
      set(value) {
        this.panelconfig.color = value
      },
    },
  },
  watch: {
    panelconfig: {
      handler(newVal) {
        // check if the data source has changed and if so, get the new data and set the old data source id if not changed do nothing
        if (this.oldDataSourceId !== newVal.dataSources[0].id) {
          this.oldDataSourceId = newVal.dataSources[0].id
          this.getDevice()
        } else if (this.oldSensorId !== newVal.dataSources[0].sensorId) {
          this.oldSensorId = newVal.dataSources[0].sensorId
          this.getDataField()
        } else if (this.oldDataSourceId === newVal.dataSources[0].id || this.oldSensorId === newVal.dataSources[0].sensorId) {
          this.doneLoading = true
        } else {
          this.doneLoading = true
          this.dataSource = {
            id: '',
            name: 'CPU',
          }
          this.dataField = {
            name: 'Temperature',
            unit: 'C',
          }
          this.statistic = '21'
          this.timestamp = ''
          this.object = {}
        }
      },
      deep: true,
    },
  },
  created() {
    if (this.panelconfig.dataSources.length > 0) {
      this.doneLoading = false
      this.getDevice()
      this.getDataField()
    } else {
      this.doneLoading = true
      this.dataSource = {
        id: '',
        name: 'CPU',
      }
      this.dataField = {
        name: 'Temperature',
        unit: 'C',
      }
      this.statistic = '21'
      this.timestamp = ''
      this.object = {}
    }
  },
  methods: {
    async getDevice() {
      const getDeviceResponse = await API.graphql({
        query: queries.getDevice,
        variables: {
          id: this.panelconfig.dataSources[0].id,
        },
      })
      if (getDeviceResponse.data.getDevice != null) {
        this.doesNotExist = false
        this.dataSource = getDeviceResponse.data.getDevice
        if (this.dataSource.objectDevicesId != null) {
          this.getObject()
        }
      } else {
        this.doesNotExist = true
        this.doneLoading = true
      }
    },
    async getDataField() {
      const getDataFieldResponse = await API.graphql({
        query: queries.getSensor,
        variables: {
          id: this.panelconfig.dataSources[0].sensorId,
        },
      })
      if (getDataFieldResponse.data.getSensor != null) {
        this.dataField = getDataFieldResponse.data.getSensor
        this.getData()
      }
    },
    async getData() {
      this.doneLoading = false
      const workspace = JSON.parse(localStorage.getItem('workspace')).id
      const getWorkspaceResponse = await API.graphql({
        query: queries.getWorkspace,
        variables: {
          id: workspace,
        },
      })
      this.workspacetoken = getWorkspaceResponse.data.getWorkspace.workspacetoken
      const db = `${getWorkspaceResponse.data.getWorkspace.id}.${process.env.VUE_APP_AMPLIFY_ENV}`
      const table = this.dataSource.deviceModelDevicesId
      const apiName = 'TimestreamAPI'
      const path = '/items'
      const query = `SELECT * FROM "${db}"."${table}" where id = '${this.panelconfig.dataSources[0].id}' and measure_name = '${this.dataField.identifier}' ORDER BY time DESC LIMIT 1`
      const myInit = {
        headers: {
          workspace,
          workspacetoken: this.workspacetoken,
        },
        queryStringParameters: {
          query,
        },
      }
      await API.get(apiName, path, myInit).then(response => {
        if (response.timestreamData[0].length === 0) {
          this.statistic = 'No Data'
          this.timestamp = 'No Data'

          this.doneLoading = true
        } else {
          // eslint-disable-next-line prefer-destructuring, camelcase, no-undef
          this.statistic = response.timestreamData[0][0]['measure_value::double']
          this.timestamp = response.timestreamData[0][0].time
          this.doneLoading = true
        }
      })
    },
    async getObject() {
      await API.graphql({
        query: queries.getObject,
        variables: {
          id: this.dataSource.objectDevicesId,
        },
      }).then(response => {
        this.object = response.data.getObject
      })
    },
  },
}
</script>
<style lang="scss">
.panelHover {
  position: relative;
   width: 100%; /* Full width (cover the whole page) */
  height: 100%; /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5); /* Black background with opacity */
  z-index: 0; /* Specify a stack order in case you're using a different order for other elements */
  cursor: pointer; /* Add a pointer on hover */
}
.textCenter {
  text-align: center;
}
.overlay {
  z-index: 1000;
  position: relative;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(5px); /* Add blur effect */
  color: #fff;
}
</style>
